"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ABM = exports.CMS = exports.PIESYNC = exports.HOMEMADE = exports.FOR_AGENCIES = exports.FOR_STARTUPS = exports.NEW = exports.POPULAR = void 0;
var POPULAR = 'popular';
exports.POPULAR = POPULAR;
var NEW = 'new';
exports.NEW = NEW;
var FOR_STARTUPS = 'startups';
exports.FOR_STARTUPS = FOR_STARTUPS;
var FOR_AGENCIES = 'agencies';
exports.FOR_AGENCIES = FOR_AGENCIES;
var HOMEMADE = 'hubspot';
exports.HOMEMADE = HOMEMADE;
var PIESYNC = 'piesync';
exports.PIESYNC = PIESYNC;
var CMS = 'cms';
exports.CMS = CMS;
var ABM = 'abm';
exports.ABM = ABM;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/urlSlugs/CollectionSlug.js
// module id = 590
// module chunks = 209 210 211 212 213